import { useEffect } from 'react';
import { useAppDispatch } from '../store';
import { setAnalyticsData } from '../store/events';
import { useAnalyticsData } from './useAnalyticsData';

export const useSyncAnalyticsToStorage = () => {
  const dispatch = useAppDispatch();
  const analyticsData = useAnalyticsData();

  useEffect(() => {
    dispatch(setAnalyticsData(analyticsData));
  }, [dispatch, analyticsData]);
};
